import PropTypes from 'prop-types';
import React from 'react';
import { ReactComponent as CheckIconCircle } from '../../assets/check-icon-circle.svg';
import { ReactComponent as FBIconCircle } from '../../assets/fb-icon-circle.svg';
import { ReactComponent as RocketIconCircle } from '../../assets/rocket-icon-circle.svg';
import { ReactComponent as WAIconCircle } from '../../assets/wa-icon-circle.svg';
import WizardStep from './WizardStep';
import { STEP_STATUS } from './constants';

const WizardProgress = ({ stepStatus }) => {
    return (
        <div className="progress-indicator">
            <WizardStep icon={<RocketIconCircle />} text="Get Started" status={stepStatus.step1} />
            <span>—</span>
            <WizardStep
                icon={<WAIconCircle />}
                text="WhatsApp Business Setup"
                status={stepStatus.step2}
            />
            <span>—</span>
            <WizardStep
                icon={<FBIconCircle />}
                text="Connect to Facebook"
                status={stepStatus.step3}
            />
            <span>—</span>
            <WizardStep
                icon={<CheckIconCircle />}
                text="Integration Successful"
                status={stepStatus.step4}
            />
        </div>
    );
};

WizardProgress.propTypes = {
    stepStatus: PropTypes.shape({
        step1: PropTypes.oneOf([STEP_STATUS.ACTIVE, STEP_STATUS.PROCESSED, STEP_STATUS.INACTIVE, '']),
        step2: PropTypes.oneOf([STEP_STATUS.ACTIVE, STEP_STATUS.PROCESSED, STEP_STATUS.INACTIVE, '']),
        step3: PropTypes.oneOf([STEP_STATUS.ACTIVE, STEP_STATUS.PROCESSED, STEP_STATUS.INACTIVE, '']),
        step4: PropTypes.oneOf([STEP_STATUS.ACTIVE, STEP_STATUS.PROCESSED, STEP_STATUS.INACTIVE, '']),
    }).isRequired,
};

export default WizardProgress; 